module.exports = __webpack_public_path__ + "fa4da2fe6cee4a114abaa2c8cbc17950.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/logo/Spotin_TM_Logo_Off-White_Small_RGB.png
// module id = 112
// module chunks = 0